<template>
  <div
    data-cy="new-token-block"
    class="flex flex-col gap-3 rounded bg-orange-50 px-4 py-3"
  >
    <div class="flex items-center gap-2">
      <div>
        <icon-base
          :icon="IconWarningTriangle"
          class="shrink-0 text-orange-400"
          width="16"
          height="16"
        />
      </div>
      <span data-cy="new-token-warning" class="text-sm text-gray-700">
        {{ $t("EMPLOYEES.ACCESS_TOKENS.COPY_TOKEN_WARNING") }}
      </span>
    </div>
    <div
      class="flex items-center gap-2 rounded border border-gray-200 bg-white px-3 py-2"
    >
      <span
        data-cy="new-token-value"
        class="min-w-0 flex-1 truncate font-mono text-sm text-gray-400"
      >
        {{ token }}
      </span>

      <copy-button data-cy="new-token-copy-button" :text="token">
        <icon-base
          :icon="IconCopy"
          width="16"
          height="16"
          view-box="0 0 20 20"
        />
      </copy-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import IconCopy from "@/components/icons/IconCopy.vue";
import IconWarningTriangle from "@/components/icons/IconWarningTriangle.vue";
import CopyButton from "@/components/ui/buttons/CopyButton.vue";

import type { CreatedAccessToken } from "@/schemas/accessTokens";

defineProps<{
  token: CreatedAccessToken["token"];
}>();
</script>
